module.exports = __webpack_public_path__ + "img/visa.6c0bb2d0.svg";